import React, { useState, useContext, useEffect } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import Heading from '@react/react-spectrum/Heading'

import { RootContext } from '../../../root/RootContext'
import { ProfileContext } from '../../../root/ProfileContext'

import { Filter } from '../../../components/Filter'
import Well from '@react/react-spectrum/Well'

import { EE, CHANNEL } from '../../../config/constants'

import {
  CallCenter,
  Checkout,
  AddToCart,
  ProductView,
  GenericEvent,
  Offer,
  GeoFencing,
  RegisterAccount,
  Chatbot,
  PageView,
} from './TimelineComponents'

import './ActivityTimeline.scss'

export default function ActivityTimeline({ meta, content }) {
  const rootContext = useContext(RootContext)

  const profileContext = useContext(ProfileContext)

  const currentProfile = profileContext.state.currentProfile
  const tenantId = '_' + rootContext?.project?.integrations?.aep?.imsOrg?.tenantID
  const channel = CHANNEL.replace('$tenantId', tenantId)

  const [eventTypesFilter, setEventTypesFilter] = useState(content.eventTypes)
  const [sourcesFilter, setSourcesFilter] = useState(content.sources)
  const [defaultActivities, setDefaultActivities] = useState()
  const [activities, setActivities] = useState()

  const updateEventTypesFilter = (val) => {
    if (val === 'addAll') {
      setEventTypesFilter(content.eventTypes)
    } else if (val == 'removeAll') {
      setEventTypesFilter([])
    } else {
      setEventTypesFilter([...eventTypesFilter, val])
    }
  }

  const updateSourcesFilter = (val) => {
    if (val === 'addAll') {
      setSourcesFilter(content.sources)
    } else if (val == 'removeAll') {
      setSourcesFilter([])
    } else {
      setSourcesFilter([...sourcesFilter, val])
    }
  }

  useEffect(() => {
    if (currentProfile) {
      let ee = currentProfile?.experienceEvents.sort((a, b) => b.timestamp - a.timestamp)
      ee = _.filter(ee, (e) => _.includes(sourcesFilter, _.get(e, `entity.${channel}`)))
      setDefaultActivities(ee)
    }
  }, [currentProfile])

  useEffect(() => {
    let newActivities = _.filter(defaultActivities, (ee) => _.includes(sourcesFilter, _.get(ee, `entity.${channel}`)))
    newActivities = _.filter(newActivities, (ee) => _.includes(eventTypesFilter, ee.entity.eventType))
    setActivities(newActivities)
  }, [defaultActivities, sourcesFilter, eventTypesFilter])

  //One component per event type
  const components = {
    [EE.ADD_TO_CART]: AddToCart,
    [EE.CHECKOUT]: Checkout,
    [EE.PRODUCT_VIEW]: ProductView,
    [EE.ORDER_TRACKING]: CallCenter,
    [EE.RATE_CALL]: CallCenter,
    [EE.OFFER_ACCEPTED]: Offer,
    [EE.OFFER_DECLINED]: Offer,
    [EE.POI_ENTRY]: GeoFencing,
    [EE.POI_EXIT]: GeoFencing,
    [EE.REGISTER_ACCOUNT]: RegisterAccount,
    [EE.BOT_INTERACTION]: Chatbot,
    [EE.PAGE_VIEW]: PageView,
  }

  return (
    <div className='profile-module activity-timeline'>
      {currentProfile && (
        <div align='center'>
          {content.description && <Well>{content.description}</Well>}
          <div className='module-content'>
            {Array.isArray(activities) &&
              activities?.map((event) => {
                let CustomComponent = components.hasOwnProperty(event.entity.eventType)
                  ? components[event.entity.eventType]
                  : GenericEvent
                return (
                  <CustomComponent
                    channel={_.get(event, `entity.${channel}`)}
                    event={event}
                    tenantId={tenantId}
                    key={`timeline-${event.entityId}`}
                  />
                )
              })}
          </div>
          <div className='timeline-legend'>
            {
              <Filter
                label='Event Types'
                defaultFilter={content.eventTypes}
                onRemove={(e) => setEventTypesFilter(eventTypesFilter.filter((v) => v !== e))}
                onChange={(val) => updateEventTypesFilter(val)}
              />
            }
            {
              <Filter
                label='Channels'
                defaultFilter={content.sources}
                onRemove={(e) => setSourcesFilter(sourcesFilter.filter((v) => v !== e))}
                onChange={(val) => updateSourcesFilter(val)}
              />
            }
          </div>
        </div>
      )}
    </div>
  )
}

ActivityTimeline.requiresLaunch = false
